var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"img-content-wrap"},_vm._l((_vm.params.list),function(items,idx){return _c('el-image',{key:idx,attrs:{"src":items.image},on:{"click":function($event){return _vm.itemClick(items)}}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }